import { AssessmentMeasurementConfiguration, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { assessmentMeasurementConfigurationClient } from './AssessmentMeasurementConfigurationClient';

const factory = createStudyEntityHookFactory<AssessmentMeasurementConfiguration>(
    StudyEntityType.AssessmentMeasurementConfiguration
);

export const useAssessmentMeasurementConfigurations = factory.list(assessmentMeasurementConfigurationClient.list);
